/*
  component: widget-demo-page
  title: Widget Demo Canary Page
  deps: fot-widget
*/
import { appendReturnTo } from '../utils/return-to-url.js';

class WidgetDemoPage extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  render() {
    this.innerHTML = `
      <div class="card">
        <div class="card-body">
          <h2>🧩 Widget Demo</h2>
          <p>Sandboxed iframe from the widget host with MessageChannel communication.
            <a href="${appendReturnTo('/docs/widgets')}">Widget docs</a> ·
            <a href="${appendReturnTo('/docs/widgets/message-channel')}">MessageChannel protocol</a>
          </p>
          <fot-widget widget-id="1"></fot-widget>
        </div>
      </div>
    `;
  }
}

customElements.define('widget-demo-page', WidgetDemoPage);
